<script>
/* global axios */
// [AstraChat] Canal NotificaMe (provedor virtual, token por conta). Lista os canais
// REAIS da conta NotificaMe (list_channels) e conecta cada um na hora — SEM QR (o
// canal já existe no hub). Conectar cria a inbox Channel::Api + registra o webhook.
// Ver notificame-integration-spec.
import { mapGetters } from 'vuex';
import { useAlert } from 'dashboard/composables';
import router from '../../../../index';
import PageHeader from '../../SettingsSubPageHeader.vue';
import NextButton from 'dashboard/components-next/button/Button.vue';

export default {
  components: { PageHeader, NextButton },
  data() {
    return {
      loading: true,
      error: '',
      channels: [],
      connectingId: null,
      brandName: 'NotificaMe',
      subtitle: '',
    };
  },
  computed: {
    ...mapGetters({ accountId: 'getCurrentAccountId' }),
  },
  mounted() {
    this.loadChannels();
  },
  methods: {
    async loadChannels() {
      this.loading = true;
      this.error = '';
      try {
        const { data } = await axios.get(
          `/api/v1/accounts/${this.accountId}/kanban/connections/notificame/channels`
        );
        this.channels = data.data || [];
        this.brandName = data.brand_name || 'NotificaMe';
        this.subtitle = data.subtitle || '';
      } catch (e) {
        this.error =
          e?.response?.data?.error ||
          `Não foi possível listar os canais do ${this.brandName}.`;
      } finally {
        this.loading = false;
      }
    },
    channelBadge(ch) {
      if (ch.connected) return { label: 'Conectado', cls: 'bg-n-teal-3 text-n-teal-11' };
      if (!ch.allowed) return { label: 'Não atribuído', cls: 'bg-n-alpha-2 text-n-slate-11' };
      if (ch.quota_reached) return { label: 'Limite atingido', cls: 'bg-n-ruby-3 text-n-ruby-11' };
      return { label: 'Disponível', cls: 'bg-n-amber-3 text-n-amber-11' };
    },
    async connect(ch) {
      if (!ch.allowed || ch.connected || ch.quota_reached) return;
      this.connectingId = ch.id;
      try {
        const { data } = await axios.post(
          `/api/v1/accounts/${this.accountId}/kanban/connections/notificame/connect`,
          { channel_id: ch.id, channel_type: ch.channel, channel_name: ch.name }
        );
        useAlert(`Canal ${this.brandName} conectado.`);
        router.replace({
          name: 'settings_inbox_show',
          params: { inboxId: data.inbox_id },
        });
      } catch (e) {
        useAlert(
          e?.response?.data?.error ||
            `Falha ao conectar o canal ${this.brandName}.`
        );
      } finally {
        this.connectingId = null;
      }
    },
    openInbox(ch) {
      if (!ch.inbox_id) return;
      router.push({ name: 'settings_inbox_show', params: { inboxId: ch.inbox_id } });
    },
  },
};
</script>

<template>
  <div class="w-full h-full col-span-6 p-6">
    <PageHeader :header-title="brandName" :header-content="subtitle" />

    <div v-if="loading" class="py-6 text-n-slate-11">Carregando canais…</div>

    <div
      v-else-if="error"
      class="rounded-lg border border-n-ruby-6 bg-n-ruby-2 p-4 text-n-ruby-11"
    >
      {{ error }}
      <button class="ms-2 underline" @click="loadChannels">tentar de novo</button>
    </div>

    <div v-else-if="!channels.length" class="py-6 text-n-slate-11">
      Nenhum canal encontrado nesta conta. Contrate um canal (ou verifique o token)
      e tente novamente.
    </div>

    <ul v-else class="mt-2 flex flex-col gap-2 max-w-2xl">
      <li
        v-for="ch in channels"
        :key="ch.id"
        class="flex items-center justify-between gap-3 rounded-lg border border-n-weak p-3"
      >
        <div class="min-w-0">
          <div class="flex items-center gap-2">
            <span class="font-medium text-n-slate-12 truncate">{{ ch.name }}</span>
            <span
              class="rounded px-1.5 py-0.5 text-xs"
              :class="channelBadge(ch).cls"
            >{{ channelBadge(ch).label }}</span>
          </div>
          <div class="text-xs text-n-slate-10 truncate">{{ ch.channel }} · {{ ch.id }}</div>
        </div>
        <NextButton
          v-if="ch.connected"
          slate
          faded
          label="Abrir caixa"
          @click="openInbox(ch)"
        />
        <NextButton
          v-else
          solid
          blue
          :disabled="!ch.allowed || ch.quota_reached"
          :is-loading="connectingId === ch.id"
          label="Conectar"
          @click="connect(ch)"
        />
      </li>
    </ul>
  </div>
</template>
